import { render, staticRenderFns } from "./SummarySameName.vue?vue&type=template&id=e71ac53a&scoped=true"
import script from "./SummarySameName.vue?vue&type=script&lang=js"
export * from "./SummarySameName.vue?vue&type=script&lang=js"
import style0 from "./SummarySameName.vue?vue&type=style&index=0&id=e71ac53a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e71ac53a",
  null
  
)

export default component.exports